import axiosInstance from '../index';

export const getEvaluationConfigData = async () => {
  return axiosInstance.get(`api/elastic/evaluation_config`);
};

export const getEvaluationData = async (evaluationData, signal) => {
  return axiosInstance.post(`api/elastic/evaluation`, evaluationData, { signal: signal });
};

export const getEvaluationPlayerConfigData = async () => {
  return axiosInstance.get(`api/elastic/evaluation_player_config`);
};

export const getEvaluationPlayerData = async (data, signal) => {
  return axiosInstance.post(`api/elastic/evaluation_player`, data, { signal: signal });
};

export const getEvaluationFormData = async (id, signal) => {
  return axiosInstance.post(`api/elastic/get_evaluation_form_data`, { call_id: id }, { signal: signal });
};

export const createEvaluationFormData = async (params) => {
  return axiosInstance.post(`api/elastic/create_evaluation_form_data`, params);
};

export const viewPlayer = async (id, signal) => {
  return axiosInstance.post(
    `api/elastic/playerview/`,
    { call_id: id },
    {
      withCredentials: true,
      signal: signal
    }
  );
};

export const getTranscriptSearchData = (params) => {
  return axiosInstance.post(`api/elastic/transcript_search`, params);
};

export const getEvaluationTeamFeatureData = (params) => {
  return axiosInstance.post(`api/elastic/get_evaluation_features_base_on_team`, params);
};
